export default __webpack_public_path__ + "static/media/minus.706dd81d.svg";